import type { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid-store';
import type { CalendarEvent } from 'owa-calendar-types';
import { action } from 'satcheljs';

export interface SELECTED_EVENT_UPDATEDActionMessage {
    newValue: CalendarEvent | null;
    store: CalendarSurfaceStore;
    preserveCalendarContext?: boolean;
}

export const selectedEventUpdated: (
    newValue: CalendarEvent | null,
    store: CalendarSurfaceStore,
    preserveCalendarContext?: boolean
) => SELECTED_EVENT_UPDATEDActionMessage = action(
    'SELECTED_EVENT_UPDATED',
    (
        newValue: CalendarEvent | null,
        store: CalendarSurfaceStore,
        preserveCalendarContext?: boolean
    ): SELECTED_EVENT_UPDATEDActionMessage => ({
        newValue,
        store,
        preserveCalendarContext,
    })
);
